import AES from 'crypto-js/aes';
import UTF8 from 'crypto-js/enc-utf8';

export const encryptUserData = (data: Partial<UserCredentials>) => {
  const dataEncrypted = AES.encrypt(
    JSON.stringify(data),
    import.meta.env.VITE_ENCRYPTION_KEY
  ).toString();
  return dataEncrypted;
};

export const decryptUserData = (data: string): UserCredentials | null => {
  if (data !== null) {
    const bytes = AES.decrypt(data, import.meta.env.VITE_ENCRYPTION_KEY);
    return JSON.parse(bytes.toString(UTF8)) as UserCredentials;
  }
  return null;
};
